export const TOGGLE_DRAW = 'TOGGLE_DRAW';
export const CLOSE_DRAW = 'CLOSE_DRAW';

export type State = {
  openDraws: { [string]: boolean },
};
